<template>
  <b-nav class="nav-toggled">
    <!-- <img class="Item" src="@/assets/PentagroIcon2.png" alt="Ícone Pentagro" /> -->
    <b-nav-item-dropdown no-caret :text="$t('occurrences')" class="toggled"  id="occurrence" left>
      <b-dropdown-item @click="GerarExcel()" class="drop-item">
          <download-excel 
            name="Relatório de Ocorrências"
            :fetch="GerarExcel">
            <img
              class="dropItem"
              src="../../assets/excel.png"
              :alt="$t('relatorio-geral-das-ocorrencias')"            
            />
            {{ $t('relatorio-geral-das-ocorrencias') }}
          </download-excel>
      </b-dropdown-item>
      <template v-for="item in ocDropdownList">
        <DropDownItem 
          v-if="item.route"
          :key=item.item 
          :image=item.image 
          :route=item.route 
          :modal=item.modal
          :text=item.permission 
          :altTxt=item.tooltip 
          :title=item.tooltip>
        </DropDownItem>
        <DropDownItemModal 
          v-if="item.modal"
          :key=item.item 
          :image=item.image 
          :modal=item.modal
          :text=item.permission 
          :altTxt=item.tooltip 
          :title=item.tooltip>
        </DropDownItemModal>
      </template>
    </b-nav-item-dropdown>
    
    <b-modal id="faulttreeManagement" size="lg" hide-footer :title="$t('configurar-arvore-de-falhas')" :no-close-on-backdrop="true" >
      <ManageOccurrenceHandling></ManageOccurrenceHandling>
    </b-modal>

    <b-modal id="newOccurence" size="xl" hide-footer :title="$t('criar-ocorrencia-1')" :no-close-on-backdrop="true" >
      <newOccurrence></newOccurrence>
    </b-modal>

  </b-nav>
</template>

<script>
import { mapState } from "vuex";
import { urlMainAPI, defaultSuccess } from "@/global";
import DropDownItem from "./DropDownItem.vue"
import DropDownItemModal from "./DropDownItemModal.vue"
import ManageOccurrenceHandling from "../manageOccurrenceHandling/ManageOccurrenceHandling.vue"
import newOccurrence from "../occurrence/newOccurrence.vue"

export default {
  name: "OcurrenceDropdown",
  components: { DropDownItem, newOccurrence, DropDownItemModal, ManageOccurrenceHandling },
  computed: mapState(["user"]),
  data() {
    return {
      buildingReport: false,
      ocDropdownList: [],
      ocMonitoringList: [],
      ocImage: "Monitoramento.png",
      validKeys: {
        "ocorrencias": {
          item: "ocorrencias",
          image: "Planejamento.png",
          route: "/occurrencegrid",
          index: 2
        },
        "criarocorrencia": {
          item: "criarocorrencia",
          image: "ocorrencia2.png",
          modal: "newOccurence",
          index: 1
        },
        "configurararvoredefalhas" : {
          item: "configurararvoredefalhas",
          image: "Planejamento.png",
          modal: "faulttreeManagement",
          index: 3
        },
        "configurargatilhos" : {
          item: "configurargatilhos",
          image: "pop2.png",
          route: "/triggermanagement",
          index: 4
        },

      }
    }
  },
  methods:{
    async GerarExcel(){
      if(!this.buildingReport){
        this.buildingReport = true
        defaultSuccess(this.$t('gerando-relatorio-geral-das-ocorrencias'))
        const url = `${urlMainAPI}/getoccurrencesreport`
        const response = await this.$http.get(url);   
        this.buildingReport = false
        return response.data;
      }
      return
    },

    LoadPermission(){
      let i = 0;
      for (let key in this.user.Permissions){
        if(this.validKeys[key] && this.user.Permissions[key].allowed) {
          if(this.validKeys[key].item == "configurargatilhos" && this.user.Permissions.editargatilhos.allowed && this.user.role == 'PGDI') {
              this.ocDropdownList.push({
              ...this.user.Permissions[key], 
              ...this.validKeys[key]
            })
          } if (this.validKeys[key].item != "configurargatilhos" ) {
              this.ocDropdownList.push({
                ...this.user.Permissions[key], 
                ...this.validKeys[key]
              })
          }
        }

        if(key.match(/occurrencemonitoring/) && this.user.Permissions[key].allowed)
        {
          let obj = {};
          obj = this.user.Permissions[key]
          obj.item = key
          obj.image = this.ocImage
          obj.route = `/occurrencemonitoring/${obj.parameter}`
          obj.index = 100 + i++
          this.ocDropdownList.push(obj)
        }        
      }

      this.ocDropdownList.sort((a, b) => a.index > b.index ? 1 : a.index < b.index ? -1 : 0)
    }
  },
  created() {
    this.LoadPermission()
  }
};
</script>

<style scoped>
.txt {
  color: white;
  padding: 10px 20px;
}

/* img.Item, .printer-button {
  max-height: 37px;
  max-width: 37px;
  border-radius: 5px;
  margin: auto;
} */

img.dropItem {
  max-height: 25px;
  max-width: 25px;
  border-radius: 5px;
  margin-right: 10px;
}

.ilink {
  margin-right: 10px;
}

</style>

<style>
  .dropdown-menu {
    height: auto;
    max-height: 350px;
    overflow-y: auto;
  }
</style>